import { Icons } from "assets";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import "chart.js/auto";
import classNames from "classnames";
import { useEffect, useId, useState } from "react";
import { Bar } from "react-chartjs-2";
import YearPicker from "shared/dropdowns/yearPicker";
import SekeletonLoader from "shared/loaders/skeleton";
import { GetGraphStatsService } from "shared/services/dashboard";
import { barChartOptions, GraphLabels } from "shared/utils/constants";
import { getLeftPosition, getTopPosition } from "shared/utils/helper";
import styles from "./style.module.scss";

const BarGraph = () => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const uid = useId();

  const [activeDate, setActiveDate] = useState<
    Partial<{ name: string; value: string }>
  >({
    name: String(new Date().getFullYear()),
    value: `${new Date().getFullYear()}-01-01`,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [chart, setChart] = useState<string[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [openSelection, setOpenSelection] = useState<boolean>(false);

  const handleGetGraphData = () => {
    setLoading(true);
    GetGraphStatsService({ year: activeDate.name ? activeDate.name : "2024" })
      .then(({ data }) => {
        setChart(Object.values(data?.data));
        if (data?.data) {
          let sum: any = Object.values(data?.data).reduce(
            (acc: any, curr) => acc + curr,
            0
          );
          setTotal(sum);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (openSelection) {
      const elem = document.getElementById(
        `custom-year-container-${uid}`
      ) as HTMLDivElement;
      const optionsDropDown: HTMLDivElement | null = document.getElementById(
        `custom-year-dropdown-${uid}`
      ) as HTMLDivElement;
      if (elem && optionsDropDown) {
        const topPosition = getTopPosition(elem);
        const leftPosition = getLeftPosition(elem);
        optionsDropDown.style.top =
          Number(topPosition + elem?.clientHeight) + "px";
        optionsDropDown.style.left = leftPosition + "px";
      }
    }

    // eslint-disable-next-line
  }, [openSelection]);

  useEffect(() => {
    handleGetGraphData();
    // eslint-disable-next-line
  }, [activeDate?.name]);

  return (
    <div>
      {loading ? (
        <>
          <SekeletonLoader className={classNames(styles.chartLoader)} />
        </>
      ) : (
        <div className={classNames("w-full flex flex-col gap-3")}>
          <div className={classNames("flex items-center justify-between")}>
            <div className={classNames("flex flex-col gap-1")}>
              <div
                className={classNames(
                  classNames(styles.dateDropdownContainer, "gap-1 ")
                )}
                onClick={() => {
                  if (!loading) setOpenSelection(!openSelection);
                }}
                id={`custom-year-container-${uid}`}
              >
                <label>{activeDate?.name}</label>
                <Icons.ChevDown />
                <YearPicker
                  activeDate={activeDate}
                  setActiveDate={setActiveDate}
                  openSelection={openSelection}
                  setOpenSelection={setOpenSelection}
                  id={`custom-year-dropdown-${uid}`}
                />
              </div>
              <p className={classNames(styles.totalNumber)}>
                Number of Total Evaluations
              </p>
            </div>
            <div className={classNames("flex flex-col gap-1")}>
              <label className={classNames(styles.totalLabel)}>Total:</label>
              <p className={classNames(styles.totalValue)}>{total}</p>
            </div>
          </div>
          <Bar
            options={barChartOptions}
            data={{
              labels: GraphLabels,
              datasets: [
                {
                  label: "Dataset 1",
                  data: chart,
                  backgroundColor: "#3D3C3A",
                  borderRadius: 8,
                  hoverBackgroundColor: "#FFBE1D",
                },
              ],
            }}
            className={classNames(styles.chart)}
          />
        </div>
      )}
    </div>
  );
};

export default BarGraph;
